import {ClipboardModule} from '@angular/cdk/clipboard';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CoreCommonModule} from '@core/common.module';
import {CoreSidebarModule} from '@core/components';
import {CoreTouchspinModule} from '@core/components/core-touchspin/core-touchspin.module';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {ContentHeaderModule} from 'app/layout/components/content-header/content-header.module';
import {DocumentDetailModule} from 'app/main/pages/document-detail/document-detail.module';
import {ColorPickerModule} from 'ngx-color-picker';
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from 'ngx-mask';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {SharedModule} from '../../shared/shared/shared.module';
import {EditParticipantComponent} from './edit-participant/edit-participant.component';
import {ForwardSignatureComponent} from './more/forward-signature/forward-signature.component';
import {InviteToReadComponent} from './more/invite-to-read/invite-to-read.component';
import {InviteToSignComponent} from './more/invite-to-sign/invite-to-sign.component';
import {RejectDocumentComponent} from './more/reject-document/reject-document.component';
import {SendReminderComponent} from './send-reminder/send-reminder.component';

@NgModule({
    declarations: [
        SendReminderComponent,
        EditParticipantComponent,
        InviteToSignComponent,
        RejectDocumentComponent,
        ForwardSignatureComponent,
        InviteToReadComponent
    ],
    imports: [
        CommonModule,
        CoreCommonModule,
        ContentHeaderModule,
        NgbModule,
        NgSelectModule,
        NgScrollbarModule,
        FormsModule,
        ColorPickerModule,
        CoreTouchspinModule,
        CoreSidebarModule,
        SharedModule,
        DocumentDetailModule,
        ClipboardModule,
        NgxMaskDirective,
        NgxMaskPipe,
        TranslocoDirective
    ],
    providers: [provideNgxMask({ validation: false })]
})
export class SigningSidebarModule { }
